import { getStoreId } from "$/hooks/use-store-information"
import onboardingQueries from "$/lib/queries/onboarding-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/onboarding")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()

    if (storeId)
      queryClient.prefetchQuery(onboardingQueries.watchedStatuses(storeId))
    return { crumb: "alfred.pages.onboarding.crumbs.onboarding" }
  },
})
